/** Final slide variant — three beat-pulsing ring halos + heart-beat. */
import type { VariantProps } from '../registry';

export function FinalVariant({ slide }: VariantProps) {
  const text = slide.contentText || 'Will You?';
  return (
    <div className="preview-slide-content relative flex flex-col items-center gap-6">
      <div className="preview-ring-halo" aria-hidden />
      <div className="preview-ring-halo" aria-hidden />
      <div className="preview-ring-halo" aria-hidden />
      <p className="preview-slide-final relative z-10">{text}</p>
      <span className="preview-heart-beat text-5xl">💕</span>
    </div>
  );
}
